// Reset musí být v CSS bundlu před styly stránek (nahrazuje Tailwind preflight z apps/web), proto
// se importuje jako první.
import './styles/reset.css';
import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { App } from './App.js';
import { resolvePagePath } from './head.js';
import { cleanupLegacyPwa } from './lib/legacy-pwa-cleanup.js';

void cleanupLegacyPwa();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Element #root nebyl v index.html nalezen.');
}

const app = (
  <StrictMode>
    <App page={resolvePagePath(window.location.pathname)} />
  </StrictMode>
);

// Produkční HTML je předrenderované a klient ho hydratuje (FR-03). Vývojový server obsah
// nepředrenderovává (vite.config.ts), tam se strom vykreslí od nuly.
if (rootElement.firstElementChild) {
  hydrateRoot(rootElement, app);
} else {
  createRoot(rootElement).render(app);
}
